import { G_runningElements } from "../../utils/globals/running";
import WINDOW from "../../utils/window";
import stopRaf from "./stop-raf";

const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));
const pointer = /** @type {WindowCoordinatesProps} */ (WINDOW.get("pointer"));

const onRaf = () => {
  const raf = requestAnimationFrame((tick) => {
    let timeDifference = /** @type {Number} */ (WINDOW.get("time-difference"));

    const last = /** @type {Number} */ (WINDOW.get("now"));
    const tickDifference = tick - last;

    if (tickDifference > 100) {
      timeDifference += tickDifference;
      WINDOW.set("time-difference", timeDifference);
    }

    const time = tick - timeDifference;

    WINDOW.set("now", tick);
    WINDOW.set("time", time);

    for (const main of G_runningElements.values()) {
      main.animate(time, false);

      if (main.isVisible) {
        for (const css of main.css) {
          if (css.length) {
            // console.log(css[2]);
            css[0].setProperty(css[1], css[2], css[3]);
          }
        }
      }
    }

    const lastScrollX = /** @type {Number} */ (scroll.get("x"));
    const lastScrollY = /** @type {Number} */ (scroll.get("y"));
    scroll.set("last-raf-x", lastScrollX);
    scroll.set("last-raf-y", lastScrollY);

    const lastPointerX = /** @type {Number} */ (pointer.get("x"));
    const lastPointerY = /** @type {Number} */ (pointer.get("y"));
    pointer.set("last-raf-x", lastPointerX);
    pointer.set("last-raf-y", lastPointerY);

    if (WINDOW.get("raf-running")) {
      onRaf();
    }

    if (!G_runningElements.size) {
      stopRaf();
    }
  });

  WINDOW.set("raf", raf);
};

export default onRaf;

// rotate(calc(0deg - (1 * (0deg - -50deg))))
// rotate(calc(0deg - (1 * (0deg - 10deg - (0deg - -50deg) ) + (0deg - -50deg) )))